import { fetchProviders } from "./fetchProviders";
import { FilterMetadataApiWithCountReturn, MapData } from "./types";
import { post } from "./api";
import { Bbox } from "./types";
import { PROVIDER_CONNECTION_TYPE, DEFAULT_FLY_TO } from "./constants";
import { Config } from "Config";

export const fetchMapData = async (
    metadata: FilterMetadataApiWithCountReturn,
    options?: RequestInit
): Promise<MapData> => {
    const providers = await fetchProviders(options);
    if (!providers) {
        return {
            adminIds: [],
            spatialValues: [],
            colorMappings: {}
        };
    }

    const nonBulkProviders = providers?.filter(d => d.connectionSizeCategory !== PROVIDER_CONNECTION_TYPE.bulk);

    const adminIds = nonBulkProviders?.map(({ adminId }) => adminId);

    if (!metadata)
        return {
            adminIds: adminIds,
            spatialValues: [],
            colorMappings: {}
        };

    const colorMappings = (metadata?.["providerType"]?.options ?? []).map(({ value, color }) => {
        return {
            value,
            color
        };
    });

    const colorMappingsKeyByValue = colorMappings.reduce((prev, current) => {
        const { value, color } = current;
        prev[value] = color;
        return prev;
    }, {});

    const spatialValues = nonBulkProviders.map(({ adminId, type, name }) => {
        return {
            adminId,
            category: type,
            name
        };
    });

    return {
        adminIds,
        spatialValues,
        colorMappings: colorMappingsKeyByValue
    };
};

export const findBounds = async (args?: { propValues: string[]; propKey: string }): Promise<Bbox> => {
    if (!args) throw new Error("Must provide bbox metadata");

    const adminIds = (args?.propValues ?? []).filter(d => d != null && d.toString().trim() !== "");
    if (!adminIds?.length || adminIds?.length >= 4)
        return {
            bbox: DEFAULT_FLY_TO
        };
    const bbox = await post<Bbox>(
        `${Config.mapApi}/bbox`,
        JSON.stringify({
            ...(args ?? {}),
            propKey: "pure_strings_admin_id"
        })
    );

    return bbox;
};
